import { effects } from 'redux-saga'

import { errorPassword } from '../../../modules/service/changePassword'

export default function* validate(first, second) {
  if (!first) {
    yield effects.put.resolve(errorPassword(['Your password cannot be empty.']))

    return false
  }

  if (first !== second) {
    yield effects.put.resolve(errorPassword(['Your passwords do not match.']))

    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/service/changePassword/validate.js